module.exports = __webpack_public_path__ + "img/new_logo.35df1e92.svg";